/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Properties_HeadingInputs */



/**
* | output |
* | --- |
* | "Properties to sync" |
*
* @param {Event_Group_Sync_Properties_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_properties_heading = /** @type {((inputs?: Event_Group_Sync_Properties_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Properties_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Properties to sync")
	if (locale === "de") return /** @type {LocalizedString} */ ("Properties to sync")
	if (locale === "it") return /** @type {LocalizedString} */ ("Properties to sync")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Properties to sync")
	if (locale === "es") return /** @type {LocalizedString} */ ("Properties to sync")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Properties to sync")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Properties to sync")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Properties to sync")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Properties to sync")
	return /** @type {LocalizedString} */ ("Properties to sync")
});